import React from 'react'
import styled from 'styled-components'

import { box } from '@Globals/Style/mixins'

const StyledBurgerMenuIcon = styled.div`
  height: 17px;
  margin-top: 3px;
  span, &:before, &:after {
    position: relative;
    display: block;
    ${box({ height: '2px', width: '24px' })};
    background-color: ${({ theme }) => theme.colors.greyDark};
    margin-bottom: 5px;
  }
  &:before, &:after {
    content: '';
  }
  &:before {
    width: 21px;
  }
  &:after {
    width: 19px;
  }
`

export const BurgerMenuIcon = () => (
  <StyledBurgerMenuIcon>
    <span />
  </StyledBurgerMenuIcon>
)
